export const environment = {
    // Cloudflare Turnstile PUBLIC site key for the contact form (safe to commit). Secret is server-side only.
    TURNSTILE_SITE_KEY: '0x4AAAAAAD8l4SOfIakWHhzb',
    production: true,
    APP_VERSION: require('./../../package.json').version + '-staging',
    BASE_URL: 'https://medicai-sa-staging.azurewebsites.net',
    API_URL: 'https://medicai-sa-staging.azurewebsites.net',
    TRANSCRIPTION_WORKER_URL: 'https://mai-transcription-worker.azurewebsites.net',
    EMAIL_KEY: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbktleSI6ImViZmZjMTA0LTZiY2ItNDBjNy1hNTI3LWY2Nzk4MTc1OGUwZCIsInZhbGlkRm9yIjoic2NoZWR1bGVkSm9icyIsImVhdCI6MjUzODgwMDI5MH0.m4GK3jrvchBp6TY1sPvoOhU3EKCnkqq2nPi1b0scsWk',
    PATIENT_BASE_URL: 'https://medicai-sa-staging.azurewebsites.net',
    JWT_INVITE_SECRET: 'v@LN@flo1|Kw!#[r]q6[C2h:mh!Cz-%gxc7;K6N?ZY[C/K4Agn|Uwk<"BHrf}ugu',
    PAYFAST_URL: 'https://www.payfast.co.za/eng/process',
    PAYFAST_PASSPHRASE: 'sApPPJMWWqbbyxUsxsC3KsGQc4NmA4Dx',
    PAYFAST_MERCHANT: {
        merchant_id: "15268694",
        merchant_key: "lbx6muly2ycjl",
        return_url: "/settings?action=success",
        cancel_url: "/settings?action=cancelled",
        notify_url: "https://medicai-sa-staging.azurewebsites.net/api/payments"
    },
    PAYFAST_CONFIRMATION: {
        email_confirmation: '1',
        confirmation_address: 'contact@iqject.com',
        subscription_type: '2'
    },
    // Practice forms (tasks/patient-forms.md). OFF everywhere: the feature is built,
    // harnessed and committed, but hidden from the UI pending a decision on rollout.
    // Flipping this to true restores every entry point; nothing was deleted.
    PRACTICE_FORMS_ENABLED: false,
    // Referrals to external clinicians (tasks/referrals.md). Hidden unless true: the settings tab, the patient-file
    // referral button and the review dialog. The server refuses referral writes unless the integration is configured.
    EXPERIMENTAL_FEATURE_GROUP_IDS: ['3d266d38-63ba-4ca3-a6e4-52a39efeceab', '803aa418-3ff6-42f0-867c-6072fcba7bce'],
    LANCET_AFFILIATE_CODE: '00MEDICAI', // Set your Lancet affiliate code here
    connectEnabled: true,
    patientAppEnabled: true,
    referralsEnabled: true,
    mergeAuthorizedUserId: '511f39e1-ff14-4a6d-b35a-6fcc22923b50',
    isNative: false
};

